/*
 * Copyright (c) Nexign, JSC, 2021-2024.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Baranchikov
 * @author Viacheslav Smalenski
 * @version 1.29.0
 * @since 1.13.0
 */

import styled from 'styled-components';

import { colors, fonts } from '@theme/index';

export const SubscriberIdInfoStyled = styled.div.attrs({
    className: 'subscriber-id-info',
})`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 32px;

    .subscriber-id-error {
        grid-column: 1 / 3;
    }

    .subscriber-id-info__separate {
        grid-column: 1 / 3;
        border-bottom: 1px solid ${colors.borderColorSeparate};
    }

    .subscriber-id-info__tariff {
        grid-column-start: 1;

        .tariff__name,
        .tariff__options-title {
            ${fonts.textMainBold};
        }

        .tariff__description,
        .tariff__date {
            margin-top: 12px;
        }

        .tariff__date-plan {
            margin-top: 8px;
        }

        .tariff__option-date {
            color: ${colors.textColorOpacity};
        }

        .tariff__price {
            &.tariff__price_error {
                color: ${colors.textColorDanger};
            }
        }

        .tariff__options-title {
            margin-bottom: 8px;
        }

        .tariff__option:not(:last-child) {
            margin-bottom: 12px;
        }

        .tariff__btn,
        .megapowers_btn,
        .tariff__options {
            margin-top: 16px;
        }
    }

    .subscriber-id-info__tariff-discounts {
        .tariff-discounts__group {
            margin-bottom: 16px;
        }
    }

    .subscriber-id-info__block-account {
        grid-column-start: 1;
    }

    .subscriber-id-info__date-to {
        margin-top: 4px;
    }
`;

export const SubscriberIdInfoMegaPowersStyled = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 32px;
`;

export const MegaPowersList = styled.span`
    line-height: 32px;
    margin-top: 8px;

    & > span:not(:last-child) {
        margin-right: 8px;
    }
`;

export const SubscriberIdInfoDiscountGroupStyled = styled.div`
    &:not(:last-child) {
        margin-bottom: 32px;
    }
`;

export const ProgressBarWrapper = styled.div`
    margin-bottom: 12px;
`;
